import React from "react";
import { motion } from "framer-motion";
import { scriptsList } from "../../data/scriptList";
import AdminHeader from "../AdminHeader/AdminHeader";

export default function ScriptsDashboard() {
  const openSheet = (link, e) => {
    e.stopPropagation();
    window.open(link, "_blank");
  };

  const openScript = (path) => {
    // If it's an internal route
    if (path.startsWith("/")) {
      // Get full URL of the route
      const fullUrl = `${window.location.origin}${path}`;
      window.open(fullUrl, "_blank");
    } else {
      // For external links
      window.open(path, "_blank");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6 md:p-10">
      {/* Header */}
      <AdminHeader/>
      <div className="text-center mb-12">
        <h1 className="mt-10 text-3xl md:text-4xl font-bold text-gray-800 mb-3">
          Script Dashboard
        </h1>
        <p className="text-indigo-800 text-base md:text-xl ">
          Select any script below to open and use it instantly.
        </p>
      </div>

      {/* Script Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {scriptsList.map((script, index) => (
          <motion.div
            key={script.path}
            onClick={() => openScript(script.path)}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.04 }}
            whileHover={{ scale: 1.03 }}
            className="cursor-pointer bg-white rounded-2xl p-6 shadow-sm hover:shadow-md border border-gray-100 transition-all duration-200"
          >
            <h2 className="text-lg md:text-xl font-semibold text-gray-800 mb-2">
              {script.name}
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-2">
              {script.description}
            </p>
            {script.sheet_link && (
              <p
                onClick={(e) => openSheet(script.sheet_link, e)}
                className="text-blue-600 text-sm leading-relaxed underline cursor-pointer"
              >
                Open Sheet
              </p>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
}

